import { createContext, useContext } from 'react'
import { Admin } from '@acorns/admin-framework-binding'

interface IAuthContext {
  signIn: () => void
  signOut: () => void
  adminUser: Admin | null
}

export const AuthContext = createContext<IAuthContext>({
  signIn: () => null,
  signOut: () => null,
  adminUser: null,
})

export const useAuthContext = () => useContext(AuthContext)
